import type { GetNotificationById200SourceSourceUserAllOf } from './getNotificationById200SourceSourceUserAllOf';
import type { GetNotificationById200SourceSourceUserAllOfTwo } from './getNotificationById200SourceSourceUserAllOfTwo';

/**
 * 알림을 발생시킨 사용자 정보
 */
export type GetNotificationById200SourceSourceUser = GetNotificationById200SourceSourceUserAllOf & GetNotificationById200SourceSourceUserAllOfTwo;
